<app-backgrop class="relative z-100">
	<div class="flex flex-col justify-center items-center gap-2 w-full max-w-[626px] xl:max-w-[726px]  pt-5 xl:pt-[30px]">
		<div class="resume-container top-4 w-full">
			
			<div class="tab-container">
				<div class="tab-item first passed" [class.active]="activeTab === 1 && !(shareActive || infoActive)" (click)="setTabActive(1)">
					<img src="./assets-compressed/categories/resume/tab1.png" alt="" class="">
					<span class="tab-item__text">Career ID</span>
				</div>
				<div class="tab-item second" [class.active]="activeTab === 2  && !(shareActive || infoActive)" (click)="setTabActive(2)">
					<img src="./assets-compressed/categories/resume/tab2.png" alt="" class="">
				</div>
				<div class="tab-item third" [class.active]="activeTab === 3  && !(shareActive || infoActive)" (click)="setTabActive(3)">
					<img src="./assets-compressed/categories/resume/tab3.png" alt="" class="scale-[1.2] relative top-[2px]">
				</div>
				<div class="tab-item fourth" [class.active]="activeTab === 4  && !(shareActive || infoActive)" (click)="setTabActive(4)">
					<img src="./assets-compressed/categories/resume/tab4.png" alt="" class="">
				</div>
				<div class="tab-item fifth" [class.active]="activeTab === 5  && !(shareActive || infoActive)" (click)="setTabActive(5)">
					<img src="./assets-compressed/categories/resume/tab5.png" alt="" class="">
				</div>
			</div>
			<div class="wrapper">
				<app-dialog id="resumeModal" class="relative  [@media(min-height:935px)]:md:static w-[95%] max-w-[726px]  max-h-[95%] sm:block sm:m-auto "  [disableLoadSound]="true">

					<button class="size-[30px] [@media(min-height:935px)]:md:size-[50px] cursor-pointer absolute top-2 z-99 right-2 hovered-icon select-none" (pointerup)="playBtnClick(); reachGoal(); close.emit()">
							<img src="./assets-compressed/categories/icons/props/close.png" alt="" class="select-none">
							<img src="./assets-compressed/categories/icons/props/hover/close-hover.png" alt="" class="select-none">
					</button>
					<div class="max-h-[80dvh] overflow-y-auto -ml-3 md:ml-0 -mr-3 md:mr-0 relative">
						<div class="main-tab">
							<div class="flex justify-start pl-6 md:pl-10 mb-2 md:mb-3 items-center">
								<div class="size-[50px] md:size-[60px] [@media(min-height:935px)]:md:size-[110px] relative mr-2 [@media(min-height:935px)]:md:mr-7">
									<div class="w-full h-full bg-white border-1 rounded-full" [class.shadow-(--custom-bottom-shadow-resume)]="segments === 9">
										<app-pie-chart class="select-none relative" [segments]="segments">
										</app-pie-chart>
									</div>
									<div class="w-full h-full p-1 md:p-2 absolute top-0 left-0 z-5 rounded-full">
										<div class="w-full h-full rounded-full bg-white border-1 border-black " [class.shadow-(--custom-bottom-shadow-resume)]="segments === 9">
											@if (gender === 'male') {
												<img class="select-none" src="./assets-compressed/images/gender/boy-mini.webp">
											} @else {
												<img class="select-none" src="./assets-compressed/images/gender/girl-mini.webp">
											}
										</div>
									</div>
								</div>

								<div class="relative">
									<h1
										class="uppercase font-bold -mb-3 md:mb-0 text-2xl sm:text-3xl [@media(min-height:935px)]:md:text-5xl/[130%] text-(--custom-color-1)"
									><span [class.text-(--custom-color-1)]="isActive">CAREER ID</span></h1>
									<span class="text-[14px]/[110%] md:text-[18px]/[110%]  [@media(min-height:935px)]:md:text-[24px] shrink-0 mr-2 text-(--custom-color-4)">Твой&nbsp;карьерный&nbsp;паспорт</span>
									<img class="select-none absolute bottom-0 left-0 w-full" src="./assets-compressed/images/resume/line.png">
								</div>
							</div>

							<div class="mb-2 md:mb-3">
								<h2 class="w-[210px] text-[12px] md:text-base font-medium h-[34px] md:h-10 pt-[2px] pl-5 uppercase text-white bg-[url('./assets-compressed/images/resume/title-bg.png')] bg-contain bg-no-repeat bg-left-bottom mb-[-15px]">Твоя основа</h2>
								<div class="flex flex-col gap-1 md:gap-2 ">
									@for (item of tests; track $index) {
										<div class="flex justify-between w-full p-1 md:min-h-20 border-1 border-[#B1ACA4] rounded-[13px] bg-[#F7F5F2] items-center pr-4 relative">
											<div class="flex">
												<div class="relative select-none  shrink-0">
													<img class="w-8 [@media(min-height:935px)]:md:w-16" src="./assets-compressed/images/resume/{{item.img}}" alt="">
													<img class="w-8 [@media(min-height:935px)]:md:w-16 absolute top-0 left-0" [class.opacity-0]="!item.completed" src="./assets-compressed/images/resume/{{item.imgFull}}" alt="">
												</div>
												<div class="flex flex-col ml-2 justify-center" style="line-height: 1">
													<div class="flex " >
														<span class="mb-[2px] text-[14px] [@media(min-height:935px)]:md:text-base font-medium mr-2" [style]="item.completed ? 'color:' + item.color : ''">{{item.title}}</span>
														<span class="uppercase font-bold text-[14px] [@media(min-height:935px)]:md:text-[18px] flex items-center">{{item.name ?? ''}}</span>
													</div>
													<div>
														<span class="text-[14px] [@media(min-height:935px)]:md:text-base text-[#B1ACA4]" [style]="item.completed ? 'color: #606060' :''">{{item.value}}</span>
													</div>
												</div>
											</div>
											<div class="absolute top-2 right-2 [@media(min-height:935px)]:md:relative  [@media(min-height:935px)]:md:top-0  [@media(min-height:935px)]:md:right-0 select-none shrink-0">
												<img class="size-4 [@media(min-height:935px)]:md:size-8" src="./assets-compressed/images/resume/star.png" alt="">
												<img
													class="absolute top-0 left-0 size-4 [@media(min-height:935px)]:md:size-8"
													[class.opacity-0]="!item.completed"
													src="./assets-compressed/images/resume/star-full.png"
													alt=""
													[delayedClass]="!!item.completed"
													delayedClassName="star-completed"
												>
											</div>
										</div>
									}
								</div>
							
							</div>

							<div class="mb-2 md:mb-3">
								<h2 class="w-[210px] text-[12px] md:text-base font-medium h-[34px] md:h-10  pt-[2px] pl-5 uppercase text-white bg-[url('./assets-compressed/images/resume/title-bg.png')] bg-contain bg-no-repeat bg-left-bottom mb-[-15px]">Тебе может подойти</h2>
								<div class="flex  gap-1 md:gap-2">
									@for (item of profs; track $index; let last = $last) {
										<div class="flex justify-between w-full p-1 border-1 border-[#B1ACA4] rounded-[13px] bg-[#F7F5F2] items-center pr-2 [@media(min-height:935px)]:md:pr-4 items-start pt-2 md:min-h-[90px]">
											<div class="flex">
												<div class="relative select-none  shrink-0" [class.pl-2]="last">
													<img class="w-4 [@media(min-height:935px)]:md:w-10 " src="./assets-compressed/images/resume/{{item.img}}" alt="">
													<img class="w-4 [@media(min-height:935px)]:md:w-10 absolute top-0 left-0" [class.left-2]="last" [class.opacity-0]="!item.completed" src="./assets-compressed/images/resume/{{item.imgFull}}" alt="">
												</div>
												<div class="flex flex-col ml-1 md:ml-2 " style="line-height: 1">
													<div class="flex" >
														<span class="font-medium text-[14px] md:text-base whitespace-nowrap" [style]="item.completed ? 'color:' + item.color : ''">{{item.title}}</span>
													</div>
													<div class="-ml-[16px] md:ml-0" [class.-ml-[22px]]="last" >
														@if (item.completed) {
															<span class="uppercase font-bold text-[14px] [@media(min-height:935px)]:md:text-[18px]">{{item.value ?? ''}}</span>
														} @else {
															<span  class=" text-[14px] md:text-base text-[#B1ACA4]">{{item.value}}</span>
														}
													</div>
												</div>
											</div>
											<div class="relative select-none shrink-0">
												<img class="size-4 [@media(min-height:935px)]:md:size-8" src="./assets-compressed/images/resume/star.png" alt="">
												<img
													class="absolute top-0 left-0 size-4 [@media(min-height:935px)]:md:size-8"
													[class.opacity-0]="!item.completed"
													src="./assets-compressed/images/resume/star-full.png"
													alt=""
													[delayedClass]="!!item.completed"
													delayedClassName="star-completed"
												>
											</div>
										</div>
									}
								</div>
							</div>

							<div class="mb-2 md:mb-3">
								<h2 class="w-[210px] text-[12px] md:text-base font-medium h-[34px] md:h-10  pt-[2px] pl-5 uppercase text-white bg-[url('./assets-compressed/images/resume/title-bg.png')] bg-contain bg-no-repeat bg-left-bottom mb-[-15px]">Что влияет на выбор</h2>
								<div class="grid grid-cols-2 gap-1 md:gap-2">
									@for (item of cards; track $index; let last = $last) {
										<div class="flex  relative justify-between md:min-h-15 p-1 [@media(min-height:935px)]:md:min-h-20 border-1 border-[#B1ACA4] rounded-[13px] bg-[#F7F5F2] items-start pr-4 pt-2">
											<div class="flex [@media(min-height:935px)]:md:flex-col pl-1 md:pl-2">
												<div class="relative select-none shrink-0">
													<img class="w-6 md:w-8 [@media(min-height:935px)]:md:w-10" src="./assets-compressed/images/resume/{{item.img}}" alt="">
													<img class="w-6 md:w-8 [@media(min-height:935px)]:md:w-10 absolute top-0 left-0" [class.opacity-0]="!item.completed" src="./assets-compressed/images/resume/{{item.imgFull}}" alt="">
												</div>
												<div class="flex flex-col ml-2 justify-center"  style="line-height: 1">
													<div class="flex mt-[4px] md:mt-0">
														<span  class="font-medium  text-[14px] md:text-base" [style]="item.completed ? 'color:' + item.color : ''">{{item.title}}</span>
													</div>
													<div class="-ml-[30px] md:ml-0 mt-[4px] md:mt-0 ">
														<span  class="text-[#B1ACA4]  text-[14px] md:text-base" [style]="item.completed ? 'color: #606060' :''">{{item.value}}</span>
													</div>
												</div>
											</div>
											<div class="absolute top-2 right-2 [@media(min-height:935px)]:md:right-4 select-none ">
												<img class="size-4 [@media(min-height:935px)]:md:size-8" src="./assets-compressed/images/resume/star.png" alt="">
												<img
													class="absolute top-0 left-0 size-4 [@media(min-height:935px)]:md:size-8"
													[class.opacity-0]="!item.completed"
													src="./assets-compressed/images/resume/star-full.png"
													alt=""
													[delayedClass]="!!item.completed"
													delayedClassName="star-completed"
												>
											</div>
										</div>
									}
								</div>
							</div>
						</div>
						<div class="tab-info flex" [class.hidden]="!(activeTab !== 1 || shareActive || infoActive)">
								<div class="flex flex-col items-center justify-center w-full" [class.hidden]="!shareActive">
										<div class="relative">
											<p class="text-[24px]/[1.1] sm:text-[36px]/[1.1] xl:text-[48px]/[1.1] text-[#131313] font-semibold uppercase text-center mt-5 mb-2 relative">Поделиться игрой
												
												<img src="./assets-compressed/categories/resume/underline.png" alt="" class="absolute w-full top-full left-0">
											</p>
										</div>
										<p class="text-center text-[#131313] text-[16px]/[1.1] sm:text-[22px]/[1.1] xl:text-[24px]/[1.1] uppercase font-semibold mt-2">Выбери, как отправить ссылку</p>
										<div class="flex gap-2 sm:gap-[30px] my-[20px] sm:my-[40px]" >
											<button class="cursor-pointer size-[40px] sm:size-[50px] xl:size-[70px]" (click)="shareToTelegram()">
												<img src="./assets-compressed/categories/resume/share-tg.png" alt="">
											</button> 
											<button class="cursor-pointer size-[40px] sm:size-[50px] xl:size-[70px]" (click)="shareToVk()">
												<img src="./assets-compressed/categories/resume/share-vk.png" alt="">
											</button>
										</div>
										<app-button class="min-w-[100px]" styleType="secondary"   [widthUnset]="true" (clicked)="copyCurrentLink()">
											<span class="px-1 [@media(min-height:935px)]:md:px-7">Скопировать ссылку</span>
										</app-button>
								</div> 
								<div class="flex flex-col items-center justify-between" [class.hidden]="!infoActive">
									<div class="flex flex-col items-center">
										<div class="relative sm:mt-[50px]">
											<p class="text-[18px]/[1.1] sm:text-[26px]/[1.1] xl:text-[36px]/[1.1]  font-semibold uppercase text-center mt-5 mb-2 relative">Твой карьерный путь
												
												<img src="./assets-compressed/categories/resume/underline.png" alt="" class="absolute w-full top-full left-0">
											</p>
										</div>
										<p class="text-center text-[#606060] text-[16px]/[1.1] sm:text-[22px]/[1.1] xl:text-[24px]/[1.1] mt-2">Каждая новая часть открывает<br>следующий этап твоего карьерного пути.<br>Собери все 5 ID — и узнай, какие решения помогут тебе построить успешную карьеру.</p>
							
									</div>
									<div class="info-blocks flex">
										<div class="info-blocks-item tab1 justify-between">
											<div class="flex flex-col items-center info-blocks-item-img-container">
												<div class="info-blocks-item-img tab1">
													<img src="./assets-compressed/categories/resume/tab1.png" alt="">
												</div>
												<span class="text-[10px] sm:text-[14px] xl:text-base text-[#4FCC00] uppercase font-bold">Career ID</span>
											</div>

												<div class="progress-bar mt-2 mb-2 sm:mt-5 sm:mb-5 w-6/10 flex flex-col items-center">
													<div class="progress-info">
														<div class="progress-line progress-line-{{segments}}"></div>
													</div>
													<span>{{segments}} из 9</span>
												</div>

												<span class="text-[10px] sm:text-[14px] xl:text-base text-[#4FCC00] uppercase font-bold">В&nbsp;процессе</span>
										</div>
										<div class="info-blocks-item justify-between">
											
											<div class="flex flex-col items-center info-blocks-item-img-container">
												<div class="info-blocks-item-img ">
													<img src="./assets-compressed/categories/resume/tab2.png" alt="">
												</div>
												<span class="text-[10px] sm:text-[14px] xl:text-base text-[#696969] uppercase font-bold">Offer ID</span>
												<img src="./assets-compressed/categories/resume/lock.png" alt="" class="absolute w-3/5 top-full max-w-[50px]">

											</div>


											<span class="text-[10px]/[1.1] sm:text-[14px]/[1.1] xl:text-base/[1.1] text-[#696969] uppercase font-bold text-center">Скоро открытие</span>
										</div>
										
										<div class="info-blocks-item justify-between">
											
											<div class="flex flex-col items-center info-blocks-item-img-container">
												<div class="info-blocks-item-img ">
													<img src="./assets-compressed/categories/resume/tab3.png" alt="">
												</div>
												<span class="text-[10px] sm:text-[14px] xl:text-base text-[#696969] uppercase font-bold">Adapt ID</span>
												<img src="./assets-compressed/categories/resume/lock.png" alt="" class="absolute w-3/5 top-full max-w-[50px]">

											</div>


											<span class="text-[10px]/[1.1] sm:text-[14px]/[1.1] xl:text-base/[1.1] text-[#696969] uppercase font-bold text-center">В&nbsp;разработке</span>
										</div>
										<div class="info-blocks-item justify-between">
											
											<div class="flex flex-col items-center info-blocks-item-img-container">
												<div class="info-blocks-item-img ">
													<img src="./assets-compressed/categories/resume/tab4.png" alt="">
												</div>
												<span class="text-[10px] sm:text-[14px] xl:text-base text-[#696969] uppercase font-bold">Level ID</span>
												<img src="./assets-compressed/categories/resume/lock.png" alt="" class="absolute w-3/5 top-full max-w-[50px]">

											</div>


											<span class="text-[10px]/[1.1] sm:text-[14px]/[1.1] xl:text-base/[1.1] text-[#696969] uppercase font-bold text-center">В&nbsp;разработке</span>
										</div>
										<div class="info-blocks-item justify-between">
											
											<div class="flex flex-col items-center info-blocks-item-img-container">
												<div class="info-blocks-item-img ">
													<img src="./assets-compressed/categories/resume/tab5.png" alt="">
												</div>
												<span class="text-[10px] sm:text-[14px] xl:text-base text-[#696969] uppercase font-bold">Leader ID</span>
												<img src="./assets-compressed/categories/resume/lock.png" alt="" class="absolute w-3/5 top-full max-w-[50px]">

											</div>


											<span class="text-[10px]/[1.1] sm:text-[14px]/[1.1] xl:text-base/[1.1] text-[#696969] uppercase font-bold text-center">В&nbsp;разработке</span>
										</div>
									</div>

									<div class="flex flex-col items-center w-full">
										<span class="text-[16px]/[1.1] sm:text-[22px]/[1.1] xl:text-[24px]/[1.1] text-[#606060]">Открыто: 1 из 5 частей</span>

										
										<div class="part1-progress-bar w-full mt-2 mb-2 w-full pb-5">
											<div class="par1-progress-info">
												<div class="part1-progress-line"></div>
											</div>
											<span class="ttext-[16px]/[1.1] sm:text-[22px]/[1.1] xl:text-[24px]/[1.1]ext-[14px]/[1.1] text-[#606060]">Продолжай путь и собирай новые ID.</span>
										</div>
									</div>
								</div>


								<div class="flex flex-col items-center justify-between" [class.hidden]="(activeTab !== 2) || (shareActive || infoActive)">
									
									<div class="flex flex-col items-center">
										<div class="w-22 md:w-35 sm:w-[187px]p-2 tab-icon tab-2-icon flex flex-col items-center">
											<img src="./assets-compressed/categories/resume/tab2.png" alt="" class="w-8/10">
											<span class="uppercase text-white sm:text-[20px] font-semibold ">offer id</span>
										</div>
										<p class="text-[18px]/[1.1] sm:text-[26px]/[1.1] xl:text-[36px]/[1.1] font-semibold uppercase text-center mt-5 mb-2">2 часть - Как устроиться на работу</p>
										<p class="text-[16px] sm:text-[24px]/[1.1] xl:text-[32px]/[1.1] font-semibold uppercase bg-[url('./assets-compressed/categories/resume/line-bg.png')] bg-center bg-contain bg-no-repeat px-6 sm:px-5 sm:py-2.5 ">Скоро открытие</p>
										
										<div class="flex  mt-3 mb-3 sm:mb-5 sm:mt-8 w-9/10">
											<div class="block-item flex flex-col items-center">
												<div class="bg-[url('./assets-compressed/categories/resume/circle-bg.png')] bg-center bg-contain bg-no-repeat flex items-center justify-center">
													<img src="./assets-compressed/categories/resume/search-icon.png" alt="" class="w-8/10">
												</div>
												<span class="font-medium text-[#606060] text-[12px]/[1.1] sm:text-[16px]/[1.1] xl:text-[20px]/[1.1] text-center">Находи<br>вакансии</span>
											</div>
											<div class="block-item flex flex-col items-center">
												<div class="bg-[url('./assets-compressed/categories/resume/circle-bg.png')] bg-center bg-contain bg-no-repeat flex items-center justify-center">
													<img src="./assets-compressed/categories/resume/resume-icon.png" alt="" class="w-8/10">
												</div>
												<span class="font-medium text-[#606060] text-[12px]/[1.1] sm:text-[16px]/[1.1] xl:text-[20px]/[1.1]  text-center">Составляй<br>резюме</span>
											</div>
											<div class="block-item flex flex-col items-center">
												<div class="bg-[url('./assets-compressed/categories/resume/circle-bg.png')] bg-center bg-contain bg-no-repeat flex items-center justify-center">
													<img src="./assets-compressed/categories/resume/chat-icon.png" alt="" class="w-8/10">
												</div>
												<span class="font-medium text-[#606060] text-[12px]/[1.1] sm:text-[16px]/[1.1] xl:text-[20px]/[1.1]  text-center">Проходи<br>собеседования</span>
											</div>
											<div class="block-item flex flex-col items-center">
												<div class="bg-[url('./assets-compressed/categories/resume/circle-bg.png')] bg-center bg-contain bg-no-repeat flex items-center justify-center">
													<img src="./assets-compressed/categories/resume/mail-icon.png" alt="" class="w-8/10">
												</div>
												<span class="font-medium text-[#606060] text-[12px]/[1.1] sm:text-[16px]/[1.1] xl:text-[20px]/[1.1]  text-center">Получай<br>оффер</span>
											</div>
										</div>

										<p class="text-center text-[#606060] text-[16px]/[1.1] sm:text-[22px]/[1.1] xl:text-[24px]/[1.1]">Пройди путь от поиска вакансии до собеседования, получи оффер и собери свой Offer ID.</p>
									</div>
									<div class="flex flex-col items-center pb-4 sm:pb-8">
										<app-button class="min-w-[100px] mt-2 mb-2 sm:mb-3"  [padding]="'px-12'"  [widthUnset]="true" (click)="openSubsModal(true, 2)">
											Напомнить
										</app-button>
									</div>
								</div>
								<div class="flex flex-col items-center justify-between w-full"  [class.hidden]="(activeTab !== 3) || (shareActive || infoActive)">
									<div class="flex flex-col items-center h-full justify-center ">
										<div class="flex flex-col items-center sm:mb-10 xl:mb-16">
										<div class="w-22 md:w-35 sm:w-[187px] p-2 sm:pb-5 tab-icon  flex flex-col items-center relative">
											<img src="./assets-compressed/categories/resume/tab3.png" alt="" class="w-8/10">
											<img src="./assets-compressed/categories/resume/lock.png" alt="" class="w-1/2 absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2">
										</div>
										<p class="text-[18px]/[1.1] sm:text-[26px]/[1.1] xl:text-[36px]/[1.1] font-semibold uppercase text-center mt-5 mb-2 sm:mt-8">Следующая часть</p>
										<p class="text-[16px] sm:text-[24px]/[1.1] xl:text-[32px]/[1.1] font-semibold uppercase bg-[url('./assets-compressed/categories/resume/line-bg.png')] bg-center bg-contain bg-no-repeat px-6 sm:px-5 sm:py-2.5 ">В&nbsp;разработке</p>
										</div>
										
			

										<p class="text-center text-[#606060] text-[16px]/[1.2] sm:text-[22px]/[1.2] xl:text-[24px]/[1.2]">Мы уже работаем над продолжением. <br>Подробности появятся позже.</p>
									</div>
									<div class="flex flex-col items-center pb-4 sm:pb-8">
										<app-button class="min-w-[100px] mt-2 mb-2  sm:mb-3"  [padding]="'px-12'"  [widthUnset]="true" (click)="openSubsModal(false, 3)" >
											Напомнить
										</app-button>
									</div>
								</div>
								
								<div class="flex flex-col items-center justify-between w-full"  [class.hidden]="(activeTab !== 4) || (shareActive || infoActive)">
									<div class="flex flex-col items-center h-full justify-center ">
										<div class="flex flex-col items-center sm:mb-10 xl:mb-16">
										<div class="w-22 md:w-35 sm:w-[187px] p-2 sm:pb-5 tab-icon  flex flex-col items-center relative">
											<img src="./assets-compressed/categories/resume/tab4.png" alt="" class="w-8/10">
											<img src="./assets-compressed/categories/resume/lock.png" alt="" class="w-1/2 absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2">
										</div>
										<p class="text-[18px]/[1.1] sm:text-[26px]/[1.1] xl:text-[36px]/[1.1] font-semibold uppercase text-center mt-5 mb-2 sm:mt-8">Следующая часть</p>
										<p class="text-[16px] sm:text-[24px]/[1.1] xl:text-[32px]/[1.1] font-semibold uppercase bg-[url('./assets-compressed/categories/resume/line-bg.png')] bg-center bg-contain bg-no-repeat px-6 sm:px-5 sm:py-2.5 ">В&nbsp;разработке</p>
										</div>
										
			

										<p class="text-center text-[#606060] text-[16px]/[1.2] sm:text-[22px]/[1.2] xl:text-[24px]/[1.2]">Мы уже работаем над продолжением. <br>Подробности появятся позже.</p>
									</div>
									<div class="flex flex-col items-center pb-4 sm:pb-8">
										<app-button class="min-w-[100px] mt-2 mb-2  sm:mb-3"  [padding]="'px-12'"  [widthUnset]="true" (click)="openSubsModal(false, 4)">
											Напомнить
										</app-button>
									</div>
								</div>
								
								
								<div class="flex flex-col items-center justify-between w-full"  [class.hidden]="(activeTab !== 5) || (shareActive || infoActive)">
									<div class="flex flex-col items-center h-full justify-center ">
										<div class="flex flex-col items-center sm:mb-10 xl:mb-16">
										<div class="w-22 md:w-35 sm:w-[187px] p-2 sm:pb-5 tab-icon  flex flex-col items-center relative">
											<img src="./assets-compressed/categories/resume/tab5.png" alt="" class="w-8/10">
											<img src="./assets-compressed/categories/resume/lock.png" alt="" class="w-1/2 absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2">
										</div>
										<p class="text-[18px]/[1.1] sm:text-[26px]/[1.1] xl:text-[36px]/[1.1] font-semibold uppercase text-center mt-5 mb-2 sm:mt-8">Следующая часть</p>
										<p class="text-[16px] sm:text-[24px]/[1.1] xl:text-[32px]/[1.1] font-semibold uppercase bg-[url('./assets-compressed/categories/resume/line-bg.png')] bg-center bg-contain bg-no-repeat px-6 sm:px-5 sm:py-2.5 ">В&nbsp;разработке</p>
										</div>
										
			

										<p class="text-center text-[#606060] text-[16px]/[1.2] sm:text-[22px]/[1.2] xl:text-[24px]/[1.2]">Мы уже работаем над продолжением. <br>Подробности появятся позже.</p>
									</div>
									<div class="flex flex-col items-center pb-4 sm:pb-8">
										<app-button class="min-w-[100px] mt-2 mb-2  sm:mb-3"  [padding]="'px-12'"  [widthUnset]="true" (click)="openSubsModal(false,5)">
											Напомнить
										</app-button>
									</div>
								</div>
						</div>

					</div>
					<div class="-mx-3 sm:mx-[unset]">
							
							<div class="flex justify-center items-center h-[40px] gap-1 -mb-4 md:mb-0 mt-2 md:h-[50px] ">
								<app-button class="min-w-[100px]" style="flex-basis: 50%;" [padding]="'px-2'" [widthUnset]="true" [disabled]="!showDownloadBtn" disabledColor="black" (clicked)="download()">
									@if (!isDownloading) {
									<span class="px-1 [@media(min-height:935px)]:md:px-7">Скачать</span>

									} @else {
										<div class="overflow-hidden size-7 m-auto">
											<div class=" size-7 rounded-full border-4 border-white/20 border-t-white border-r-white animate-spin"></div>
										</div>
									}
  

								</app-button>
								<button class="info" (click)="toggleInfo()">
									<img src="./assets-compressed/categories/resume/info.png" alt="">
								</button>
								@if ( shareActive) {
									<app-button class="min-w-[100px]" style="flex-basis: 50%;" [padding]="'px-2'"  [widthUnset]="true" (clicked)="hideInfo(); hideShare();">
										<span class="px-1 [@media(min-height:935px)]:md:px-7">Вернуться</span>
									</app-button>
									
								} @else {
									<app-button class="min-w-[100px]" style="flex-basis: 50%;" [padding]="'px-2'"  [widthUnset]="true" (clicked)="showShare()">
										<span class="px-1 [@media(min-height:935px)]:md:px-7">Поделиться</span>
									</app-button>

								}


							</div>

					</div>
				</app-dialog>

			</div>

		</div>

		@if (showDownloadModal) {
			<app-backgrop>
				<app-dialog class="flex [@media(min-height:935px)]:md:min-h-[376px] max-w-9/10 w-[560px] p-2">
					<div class="flex flex-col items-center mb-5 [@media(min-height:935px)]:md:mb-10">
						<app-title class="text-(--custom-color-1)">Карьерный ID</app-title>
					</div>
					<div class="block max-w-full w-[413px] m-auto text-(--custom-color-1) text-center">
						<app-text-simple class="">Скачать файл?</app-text-simple>
					</div>
					<div class="flex justify-center flex-wrap  mt-6">
						<app-button (click)="downloadFile()">
							<span >Скачать</span>
						</app-button>
						<app-button [styleType]="'secondary'" class="mt-4">
							<span  (click)="hideModal()">Отмена</span>
						</app-button>
					</div>
				</app-dialog>
			</app-backgrop>
		}
	</div>
</app-backgrop>

@if (showModal) {
	<app-subs-modal [part]="currentPart" (closed)="closeModal()"></app-subs-modal>
}